import { decodeJwtPayload } from '@/utils/jwt'
import { createAuthSession } from '@/utils/auth-session.cjs'

const session = createAuthSession({
  local: window.localStorage,
  tab: window.sessionStorage,
  decode: decodeJwtPayload,
  makeId: () => (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`),
})

export const authSessionContext = session.context
export const isAuthSessionCurrent = session.isCurrent
export const hasAuthSessionChanged = session.hasChanged
export const adoptAuthSession = session.adopt
export const clearAuthSession = session.clear

let redirecting = false
export function sessionChangedError() {
  const error = new Error('Your browser session changed. Please sign in again.')
  error.code = 'AUTH_SESSION_CHANGED'
  return error
}

export function redirectChangedSession() {
  // Keep the recovery form usable when returning from another tab/password manager.
  if (['/login', '/admin/login'].includes(window.location.pathname)) return
  if (hasAuthSessionChanged() && !redirecting && !window.location.pathname.startsWith('/documents/shared')) {
    redirecting = true
    window.location.replace('/login?sessionChanged=1')
  }
}

export function installAuthSessionGuard(onChange) {
  const check = () => {
    if (hasAuthSessionChanged()) {
      onChange()
      redirectChangedSession()
    }
  }
  window.addEventListener('focus', check)
  window.addEventListener('storage', event => {
    if (event.key === null || ['user', 'accessToken', 'refreshToken', 'vendraw.auth.login'].includes(event.key)) {
      check()
    }
  })
}
